import React, { useEffect, useState } from "react";
import TagsEditor from "../../TagsEditor";
import TabNavigation from "../TabNavigation";
import { Title } from "./Title";
import { MetaInfo } from "./MetaInfo";
import { Actions } from "./Actions";
import { ToggleVersions } from "./ToggleVersions";
import { ResourceHeaderProps } from "./types";

export const ResourceHeader: React.FC<ResourceHeaderProps> = ({
  title,
  onTitleEdit,
  id,
  createdAt,
  versionInfo,
  format,
  tags,
  onTagsEdit,
  actions = [],
  dropdownActions = [],
  showVersions,
  onToggleVersions,
  isLoading = false,
  className,
  badgeText,
  badgeVariant,
  minimal,
  tabsProps,
}) => {
  const hasMetaInfo =
    createdAt ||
    id !== -1 ||
    (versionInfo && versionInfo.total > 1) ||
    format ||
    showVersions ||
    isLoading;

  const [prevId, setPrevId] = useState<string | number>(id);
  const [prevTitle, setPrevTitle] = useState<string>(title);

  useEffect(() => {
    if (id !== prevId || title !== prevTitle) {
      setPrevId(id);
      setPrevTitle(title);
    }
  }, [id, title, prevId, prevTitle]);

  return (
    <>
      <div className={`flex ${className}`}>
        <div className="flex-1">
          {hasMetaInfo ? (
            <div className="flex flex-col gap-y-1">
              <div className="flex items-center justify-between space-x-1">
                <div className="flex items-center justify-center gap-x-2">
                  <Title
                    key={`${id}-${title}`}
                    title={title}
                    onTitleEdit={onTitleEdit}
                    badgeText={badgeText}
                    badgeVariant={badgeVariant}
                  />
                  {tags && onTagsEdit && (
                    <div className="px-2">
                      <TagsEditor
                        tags={tags}
                        onEdit={onTagsEdit}
                        maxTags={10}
                      />
                    </div>
                  )}
                  {minimal && (
                    <div className="flex items-center">
                      <Actions
                        actions={actions}
                        dropdownActions={dropdownActions}
                      />
                    </div>
                  )}
                  {minimal && (
                    <ToggleVersions
                      standalone={true}
                      showVersions={showVersions}
                      onToggleVersions={onToggleVersions}
                      versionTotal={versionInfo?.total}
                    />
                  )}
                </div>
              </div>

              {!minimal && (
                <div className="flex items-center justify-between">
                  <MetaInfo
                    createdAt={createdAt}
                    id={id}
                    versionInfo={versionInfo}
                    format={format}
                    showVersions={showVersions}
                    onToggleVersions={onToggleVersions}
                    isLoading={isLoading}
                  />
                  <Actions
                    actions={actions}
                    dropdownActions={dropdownActions}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className="flex items-center justify-between pb-3">
              <Title
                key={`${id}-${title}`}
                title={title}
                onTitleEdit={onTitleEdit}
              />
              <Actions actions={actions} dropdownActions={dropdownActions} />
            </div>
          )}
        </div>
      </div>
      {tabsProps && <TabNavigation {...tabsProps} />}
    </>
  );
};
